import { useQuery } from '@tanstack/react-query'
import { createFileRoute, getRouteApi } from '@tanstack/react-router'
import { z } from 'zod'

import { BillingPage } from '@/features/billing'
// Through `queries`, not the feature index: a loader is eager by construction.
import { invoicesQuery, plansQuery } from '@/features/billing/queries'

import { sessionQuery } from '@/app/router/session'

const searchSchema = z.object({
  invoiceId: z.string().optional(),
})

export const Route = createFileRoute('/_auth/billing')({
  validateSearch: searchSchema,
  // Both, because the page draws both above the fold — the plan grid and the
  // invoice table — and waiting for one to then reserve nothing for the other
  // is the shape this whole change removes.
  loader: ({ context }) =>
    Promise.all([
      context.queryClient.ensureQueryData(plansQuery()),
      context.queryClient.ensureQueryData(invoicesQuery()),
    ]),
  component: BillingRoute,
})

const routeApi = getRouteApi('/_auth/billing')

function BillingRoute() {
  const { invoiceId } = routeApi.useSearch()
  const navigate = routeApi.useNavigate()
  const { data: session } = useQuery(sessionQuery())

  return (
    <BillingPage
      subscription={session?.subscription ?? null}
      scheduledSubscription={session?.scheduledSubscription ?? null}
      invoiceId={invoiceId}
      onInvoiceChange={(next) => void navigate({ search: (prev) => ({ ...prev, invoiceId: next }) })}
    />
  )
}
